import { Inject, Injectable, Injector, LOCALE_ID } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
@Injectable()
export class DocumentsDDBClaimantService extends BaseApiService { // CAD -DDB Claimant controller
  constructor(
    protected injector: Injector,
    @Inject(LOCALE_ID) protected localeId: string
  ) {
    super(injector);
  }

  get claimantBPUrl(): string {
    return `${this.endPointBP}/cad/duty-drawback/claimant`;
  }

  public getUploadUrl(): string {
    return `${this.claimantBPUrl}/file-upload`;
  }
}
